module.exports.setup = () => {
    import("bootstrap/js/modal").then(deps => {
        $(() => {
            let $items = $(".confirmation");

            if ($items.length) {
                Promise.all([import("bootstrap/js/modal")]).then(deps => {
                    $(".confirmation").each(function() {
                        var self = this;
                        $(this).on("click", function(ev) {
                            ev.preventDefault();
                            let message = $(self).data("message");
                            let confirmationPhrase = $(self).data("confirmation-phrase");

                            if (confirmationPhrase) {
                                message += ` Type <strong>${confirmationPhrase}</strong> to confirm.<br><br>`;
                            }

                            const newTitle = $(this).data("title");
                            if (newTitle) {
                                const originalTitle = $("#confirmation-modal-title").text();
                                $("#confirmation-modal-title").data("original-title", originalTitle);
                                $("#confirmation-modal-title").text(newTitle);
                            }

                            $("#confirmation-modal-body").html(message);
                            let $confirmationModalConfirm = $("#confirmation-modal-confirm");

                            let $confirmationPhraseInput;
                            if (confirmationPhrase) {
                                $confirmationPhraseInput = $(`<input class="form-control" />`);
                                $("#confirmation-modal-body").append($confirmationPhraseInput);

                                $confirmationModalConfirm.attr("disabled", true);

                                $confirmationPhraseInput.on("keyup", event => {
                                    if (event.keyCode === 13) $("#confirmation-modal-confirm").click();

                                    $confirmationPhraseInput.val() !== confirmationPhrase
                                        ? $confirmationModalConfirm.attr("disabled", true)
                                        : $confirmationModalConfirm.removeAttr("disabled");
                                });
                            }

                            $("#confirmation-modal").modal();

                            if ($(this).data("confirmation-form-submit")) {
                                let $self = $(this);
                                $("#confirmation-modal-confirm").on("click", function() {
                                    if (confirmationPhrase) {
                                        $confirmationPhraseInput.siblings(".help-block").remove();
                                        if ($confirmationPhraseInput.val() !== confirmationPhrase) {
                                            $confirmationModalConfirm.removeClass("loading");
                                            $confirmationModalConfirm.removeAttr("disabled");
                                            $confirmationPhraseInput.after(
                                                `<span class="help-block danger regular-fs"><span class="tapicon tapicon-inherit-font-size tapicon-warning"></span> Inputed text does not match the confirmation text.</span>`,
                                            );

                                            return;
                                        }
                                    }

                                    $self.parents("form")[0].submit();
                                });
                            } else {
                                $("#confirmation-modal-confirm").attr("href", $(self).attr("href"));
                            }

                            $("#confirmation-modal-confirm").click(function() {
                                $(document).trigger("confirmation-modal-confirmed", $("#confirmation-modal"));
                            });
                        });
                    });

                    $("#confirmation-modal").on("hidden.bs.modal", function() {
                        $("#confirmation-modal-confirm").removeClass("loading");
                        $("#confirmation-modal-confirm").removeAttr("disabled");

                        const originalTitle = $("#confirmation-modal-title").data("original-title");
                        if (originalTitle) {
                            $("#confirmation-modal-title").text(originalTitle);
                        }
                    });
                });
            }
        });
    });
};
